export const CheckCircleIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.242" height="9.172" viewBox="0 0 13.242 9.172">
        <path id="Path_953" data-name="Path 953" d="M-14659.8,16459.744l3.712,3.711,7.056-7.059" transform="translate(14661.041 -16455.158)" fill="none" stroke={props?.color?props?.color:"#fff"} stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" />
    </svg>

)